module.exports = __webpack_public_path__ + "img/facilityInfo_3_3.a8120fd3.jpg";